import BasePainterTool from './BasePainterTool';
import TOOL_NAMES from './constants/toolNames';

export default class EdgeTool extends BasePainterTool {
  constructor(props = {}) {
    const defaultProps = { name: TOOL_NAMES.EDGE_TOOL };
    const initialProps = Object.assign(defaultProps, props);
    super(initialProps, 'edge');
  }
}
